module.exports = __webpack_public_path__ + "static/media/chiapas_aguaazul_trigosuave_10.66aad6ce.png";